import React from 'react';
import PropTypes from 'prop-types';

import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const TYPES = ['error', 'success'];

const CONTAINERS = {
  error: style(View, styles.containerError),
  success: style(View, styles.containerSuccess)
};
const COMPONENTS = {
  error: style(Text, styles.error),
  success: style(Text, styles.success),
};
const MessagesContainer = style(View, styles.messagesContainer);

const Message = ({ type, children }) => {
  if (!TYPES.includes(type))
    return console.error('<Message /> type unrecognized: ', type);
  const Container = CONTAINERS[type];
  const Component = COMPONENTS[type];
  return (
    <Container>
      <MessagesContainer>
        {Array.isArray(children)
          ? children.map((child, index) => (
              <Component size="small" key={index}>{`• ${child}`}</Component>
            ))
          : children}
      </MessagesContainer>
    </Container>
  );
};

Message.propTypes = {
  type: PropTypes.oneOf(TYPES),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.element,
    PropTypes.string
  ]).isRequired
};

Message.defaultProps = {
  type: 'error'
};

export default Message;
